import { Injectable } from '@angular/core';
import { createFrom, EventService, ProductSearchService } from '@spartacus/core';
import { map, skip, switchMap } from 'rxjs/operators';
import { NavigationEvent } from '@spartacus/storefront';
import { EMPTY } from 'rxjs';
import { FbqGgSearchPageEvent } from './fbq-gg-search-page-event';

@Injectable({
  providedIn: 'root',
})
export class FbqGgSearchPageEventBuilder {
  constructor(
    private eventService: EventService,
    private productSearchService: ProductSearchService
  ) {
    const searchResults$ = this.productSearchService.getResults().pipe(skip(1));

    const fbqGgSearchResultsEventSource = this.eventService.get(NavigationEvent).pipe(
      switchMap((navigationEvent: NavigationEvent) => {
        if (navigationEvent?.semanticRoute !== 'search') {
          return EMPTY;
        }

        return searchResults$.pipe(
          map(() =>
            createFrom(FbqGgSearchPageEvent, {
              event: 'ViewContent',
            })
          )
        );
      })
    );

    eventService.register(FbqGgSearchPageEvent, fbqGgSearchResultsEventSource);

    const fbqGgSearchPageEventSource = this.eventService.get(NavigationEvent).pipe(
      switchMap((navigationEvent: NavigationEvent) => {
        if (navigationEvent?.semanticRoute !== 'search') {
          return EMPTY;
        }

        return searchResults$.pipe(
          map(() =>
            createFrom(FbqGgSearchPageEvent, {
              event: 'Search',
            })
          )
        );
      })
    );

    eventService.register(FbqGgSearchPageEvent, fbqGgSearchPageEventSource);
  }
}
